var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @keyframes a0_t {\n            0% {\n                transform: translate(28.8px, 35.2px) scale(.4, .4) translate(-72px, -88px);\n                animation-timing-function: cubic-bezier(.4, 0, .6, 1);\n            }\n\n            50% {\n                transform: translate(28.8px, 105.6px) scale(.4, .4) translate(-72px, -88px);\n                animation-timing-function: cubic-bezier(.4, 0, .6, 1);\n            }\n\n            100% {\n                transform: translate(28.8px, 35.2px) scale(.4, .4) translate(-72px, -88px);\n            }\n        }\n    ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.2,9.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.8,35.2) scale(.4,.4) translate(-72,-88)",
    style: {
      animation: "2s linear infinite both a0_t"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M72 0v176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M0 104l72 72l72-72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f2b468c614a0cfad389d0c988784aba9.svg";
export { ForwardRef as ReactComponent };